
import './TeamPage.css';

const TeamPage = () => {
  const boardMembers = [
    {
      id: 1,
      name: 'Sweetness Nomfusi Vos',
      position: 'Chairperson',
      image: '/team/sweetness.jpg',
      email: 'sweetness@kwcdp.co.za',
      description: 'Sweetness leads our board with extensive experience in community development and strategic planning. She brings vision and leadership to guide KWCD\'s mission of empowering women and children in Kayamandi.'
    },
    {
      id: 2,
      name: 'Liah Faku',
      position: 'Deputy Chairperson',
      image: '/team/liah.jpg',
      email: 'liah@kwcdp.co.za',
      description: 'Liah supports the chairperson in governance and strategic decision-making. Her expertise in community engagement and program development helps shape our organization\'s direction.'
    },
    {
      id: 3,
      name: 'Luzuko Sizila',
      position: 'Secretary',
      image: '/team/luzuko.jpg',
      email: 'luzuko@kwcdp.co.za',
      description: 'Luzuko manages our administrative operations and ensures proper documentation and communication within the organization and with our stakeholders.'
    },
    {
      id: 4,
      name: 'Mahlubi Nkonzo',
      position: 'Board Member',
      image: '/team/mahlubi.jpg',
      email: 'mahlubi@kwcdp.co.za',
      description: 'Mahlubi contributes valuable insights and oversight to our programs, ensuring they align with our mission and meet community needs effectively.'
    },
    {
      id: 5,
      name: 'Onezwa Siko',
      position: 'Treasurer',
      image: '/team/onezwa.jpg',
      email: 'onezwa@kwcdp.co.za',
      description: 'Onezwa oversees our financial management, ensuring transparency, accountability, and sustainable resource allocation for all our community programs.'
    },
    {
      id: 6,
      name: 'Busisiwe Ndlhlovu',
      position: 'Board Member',
      image: '/team/busisiwe.jpg',
      email: 'busisiwe@kwcdp.co.za',
      description: 'Busisiwe brings diverse perspectives and community insights to our board, helping us better understand and serve the Kayamandi community.'
    }
  ];

  const operationalStaff = [
    {
      id: 1,
      name: 'Zimkitha',
      position: 'Project Centre',
      image: '/team/zimkitha.jpg',
      email: 'zimkitha@kwcdp.co.za',
      description: 'Our dedicated project centre team manages day-to-day operations and coordinates various community initiatives.'
    },
    {
      id: 2,
      name: 'Lelethu Nelisiwe Jodwana',
      position: 'Program Officer',
      image: '/team/lelethu.jpg',
      email: 'lelethu@kwcdp.co.za',
      description: 'Lelethu coordinates and oversees our educational and community development programs, ensuring they run smoothly and effectively.'
    }
  ];

  const volunteers = [
    {
      id: 1,
      name: 'Community Volunteer 1',
      position: 'Volunteer',
      image: '/team/Volunteer1.jpg',
      email: 'volunteer1@kwcdp.co.za',
      description: 'Dedicated community member supporting various programs and initiatives.'
    },
    {
      id: 2,
      name: 'Community Volunteer 2',
      position: 'Volunteer',
      image: '/team/Volunteer2.jpg',
      email: 'volunteer2@kwcdp.co.za',
      description: 'Passionate volunteer contributing time and skills to community development.'
    }
  ];

  return (
    <div className="team-page">
      {/* Hero Section */}
      <section className="team-hero">
        <div className="container">
          <h1>Our Team</h1>
          <p>Meet the dedicated individuals working to make a difference in the Kayamandi community</p>
        </div>
      </section>

      {/* Business Owner Section */}
      <section className="team-section">
        <div className="container">
          <div className="section-header">
            <h2>Head of Organization</h2>
            <p>The visionary behind our organization</p>
          </div>
          
          <div className="business-owner-card">
            <div className="owner-image-container">
              <img 
                src="/team/gladys.jpg" 
                alt="Gladys Bakubaku" 
                className="owner-image"
              />
              <div className="email-button-container">
                <a 
                  href="mailto:gladys@kwcdp.co.za" 
                  className="email-button" 
                  title="Email Gladys Bakubaku"
                >
                  <i className="fas fa-envelope"></i>
                  <span>Email Gladys</span>
                </a>
              </div>
            </div>
            <div className="owner-info">
              <h3>Gladys Ntombezanel Bakubaku – Vos</h3>
              <span className="position">Founder of Kayamandi Women Children's Development Project</span>
              <p>Gladys Bakubaku is a dedicated and passionate resident of Kayamandi, who has been instrumental in driving the Kayamandi Women and Children Development Project (KWCDP) forward since its inception in 2007. As a trained Social Auxiliary Worker, Gladys brings a wealth of knowledge and experience to the project, with a deep understanding of the specific needs and challenges faced by women and children in the community.</p>
              
              <h4>Unique Perspective</h4>
              <p>Gladys' dual role as a resident and social worker gives her a unique insight into the nature and extent of abuse within the community. This perspective enables her to develop targeted and effective solutions to address the complex issues faced by women and children in Kayamandi.</p>
              
              <h4>Leadership and Vision</h4>
              <p>Gladys' passion and vision for the project have been instrumental in its growth and success. Her leadership has brought together community members, private and public funders, volunteers, and the South African Police Service (SAPS) to support the project's mission.</p>
              
              <h4>Community-Driven Approach</h4>
              <p>Under Gladys' guidance, the KWCDP has adopted a community-driven approach, recognizing the importance of community involvement and participation in creating lasting change. This approach has enabled the project to build strong relationships with stakeholders and to develop programs that are responsive to the needs of the community.</p>
              
              <h4>Key Skills and Expertise</h4>
              <ul>
                <li>Social work and community development</li>
                <li>Governance</li>
                <li>Leadership and management</li>
                <li>Policy-making and advocacy</li>
              </ul>
              
              <h4>Professional Experience</h4>
              <p><strong>Early Career:</strong> Worked at Lindelani Place of safety on June 1, 1995, and served as Principal Social Auxiliary Worker until October 30, 2010.</p>
              
              <p><strong>Municipal Service:</strong> Municipal Councillor in Stellenbosch Local Municipality from May 2016 to May 14, 2019.</p>
              
              <p><strong>Provincial Parliament:</strong> Member of the Western Cape Provincial Parliament since May 22, 2019, serving on committees including:</p>
              <ul>
                <li>Standing Committee on Health</li>
                <li>Standing Committee on Human Settlements</li>
                <li>Standing Committee on Social Development</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Board Members Section */}
      <section className="team-section bg-light">
        <div className="container">
          <div className="section-header">
            <h2>Board Members</h2>
            <p>Our governance and strategic leadership team</p>
          </div>
          
          <div className="team-grid">
            {boardMembers.map((member) => (
              <div key={member.id} className="team-card">
                <div className="team-image">
                  <img src={member.image} alt={member.name} />
                </div>
                <div className="team-info">
                  <h3>{member.name}</h3>
                  <span className="position">{member.position}</span>
                  <p>{member.description}</p>
                  <div className="member-email">
                    <i className="fas fa-envelope"></i>
                    <a href={`mailto:${member.email}`} className="email-address">
                      {member.email}
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Operational Staff Section */}
      <section className="team-section">
        <div className="container">
          <div className="section-header">
            <h2>Operational Staff</h2>
            <p>Our dedicated team managing day-to-day operations</p>
          </div>
          
          <div className="team-grid">
            {operationalStaff.map((member) => (
              <div key={member.id} className="team-card">
                <div className="team-image">
                  <img src={member.image} alt={member.name} />
                </div>
                <div className="team-info">
                  <h3>{member.name}</h3>
                  <span className="position">{member.position}</span>
                  <p>{member.description}</p>
                  <div className="member-email">
                    <i className="fas fa-envelope"></i>
                    <a href={`mailto:${member.email}`} className="email-address">
                      {member.email}
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Volunteers Section */}
      <section className="team-section bg-light">
        <div className="container">
          <div className="section-header">
            <h2>Our Volunteers</h2>
            <p>The heart and soul of our organization</p>
          </div>
          
          <div className="volunteers-grid">
            {volunteers.map((volunteer) => (
              <div key={volunteer.id} className="volunteer-card">
                <div className="volunteer-image">
                  <img src={volunteer.image} alt={volunteer.name} />
                  <a href={`mailto:${volunteer.email}`} className="email-link" title={`Email ${volunteer.name}`}>
                    <i className="fas fa-envelope"></i>
                    <span>Email</span>
                  </a>
                </div>
                <div className="volunteer-info">
                  <h3>{volunteer.name}</h3>
                  <span className="role">{volunteer.position}</span>
                  <p>{volunteer.description}</p>
                  <div className="member-email">
                    <i className="fas fa-envelope"></i>
                    <a href={`mailto:${volunteer.email}`} className="email-address">
                      {volunteer.email}
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          <div className="cta-section text-center">
            <h3>Join Our Team</h3>
            <p>Become a volunteer and make a difference in the Kayamandi community</p>
            <a href="/volunteer" className="btn btn-primary">Volunteer With Us</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TeamPage;
